// @ts-nocheck
import { call, put } from 'redux-saga/effects';
import {
  fetchAddressDetails,
  updateAddressDetails,
  fetchEmailDetails,
  updateEmailDetails,
  fetchPhoneDetails,
  updatePhoneDetails,
  updatePreferredLangDetails,
} from '../api';

import {
  myProfieStatesFetched,
  myProfieStatesFetchFailed,
  myProfileStatesRequest,
  updateAddressSuccess,
  updateAddressFailed,
  emailAddressDetailsFetched,
  emailAddressDetailsFetchFailed,
  updateEmailAddressSuccess,
  updateEmailAddressFailed,
  phoneDetailsFetched,
  phoneDetailsFetchFailed,
  updatePhoneSuccess,
  updatePhoneFailed,
  updateLanguageSuccess,
  updateLanguageFailed,
} from '../reducer/myProfileSlice';

export function* fetchAddressStatesSaga(action) {
  const { accountId, customerId } = action.payload;
  try {
    const response = yield call(
      fetchAddressDetails,
      'address_details',
      accountId,
      customerId
    );
    yield put(myProfieStatesFetched(response));
  } catch (error) {
    yield put(myProfieStatesFetchFailed(error?.response?.data?.detail));
    console.log('Error Response', error);
  }
}

export function* addressUpdateSaga(action) {
  try {
    const response = yield call(
      updateAddressDetails,
      'address_update',
      action.payload
    );
    yield put(updateAddressSuccess(response));
  } catch (error) {
    yield put(
      updateAddressFailed(
        error?.response?.data?.detail ||
          'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

export function* fetchEmailDetailsSaga(action) {
  const { accountId, customerId } = action.payload;
  try {
    const response = yield call(
      fetchEmailDetails,
      'email_details',
      accountId,
      customerId
    );
    yield put(emailAddressDetailsFetched(response));
  } catch (error) {
    yield put(
      emailAddressDetailsFetchFailed(
        error?.detail || 'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

export function* updateEmailDetailsSaga(action) {
  const { accountId, customerId } = action.payload;
  try {
    const response = yield call(
      updateEmailDetails,
      'email_update',
      action.payload
    );
    yield put(updateEmailAddressSuccess(response));
  } catch (error) {
    yield put(
      updateEmailAddressFailed(
        error?.detail || 'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

export function* fetchPhoneNumberSaga(action) {
  const { accountId, customerId } = action.payload;
  try {
    const response = yield call(
      fetchPhoneDetails,
      'phone_details',
      accountId,
      customerId
    );
    yield put(phoneDetailsFetched(response));
  } catch (error) {
    yield put(
      phoneDetailsFetchFailed(
        error?.data?.detail || 'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

export function* updatePhoneNumberSaga(action) {
  const { accountId, customerId } = action.payload;
  try {
    const response = yield call(
      updatePhoneDetails,
      'phone_update',
      action.payload
    );
    yield put(updatePhoneSuccess(response));
  } catch (error) {
    yield put(
      updatePhoneFailed(
        error?.data?.detail || 'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

export function* updateLanguageSaga(action) {
  const { accountId, customerId, language } = action.payload;
  try {
    const response = yield call(
      updatePreferredLangDetails,
      'language_update',
      action.payload
    );
    yield put(updateLanguageSuccess(response));
  } catch (error) {
    yield put(
      updateLanguageFailed(
        error?.data?.detail || 'something went wrong, please try again later'
      )
    );
    console.log('Error Response', error);
  }
}

// Watch sagas
// export function* watchMyProfileSagas(): Generator<any, void, unknown> {
//   yield takeLatest(myProfileStatesRequest.type, fetchAddressStatesSaga);
// }
